import { alpha, styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

import { useThemeMode } from '../../providers';

export const StyledSwitch = styled(Switch)(({ theme }) => {
  const { themeMode } = useThemeMode();

  return {
    width: 20,
    height: 12,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 6,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(4px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2.5,
      '&.Mui-checked': {
        transform: 'translateX(8px)',
        color: theme.palette.common.white,
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: 'primary.main',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 7,
      height: 7,
      borderRadius: theme.shape.borderRadius,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: themeMode === 'light' ? alpha(theme.palette.grey[700], 1) : alpha(theme.palette.grey[500], 1),
      boxSizing: 'border-box',
    },
  };
});
